import moment from "moment";
import DateUtils from "../../../utils/DateUtils";

const UserTimeFormatter = (event, field)=>{

    const date = moment(event[field]).toDate();
    const isValid = event !== null
        && event !== undefined
        && event[field]
        && DateUtils.isValidDate(date);

    if (isValid) {
        event[field] = date
    } else {
        event = [{
            ...event,
            [field]: null
        }]
    }
    return isValid ? moment(date).format('HH:mm') : '-'; 
}

export default UserTimeFormatter;